
import { Injectable, ElementRef } from '@angular/core';
import * as FileSaver from 'file-saver';
import { Workbook } from 'exceljs';



const EXCEL_EXTENSION = '.xlsx';
const CSV_EXTENSION = '.csv';
const CSV_TYPE = 'text/plain;charset=utf-8';

@Injectable({
    providedIn: 'root'
  })
export class ExportService {
  constructor( ) { }

generateReport( options ) {
    // ejeplo options
    /*
        const options = {
      fileName : 'EstadisticoVentas',
      typeFormat: 'XSLX'
      title : { 
              label: '  Reporte Estadistico de Ventas',
              font: '{ "name": "Calibri", "family": 4, "size": 16, "bold": true }',
              height: 60
              },
      subtitle : { 
              label: '  Reporte Estadistico de Ventas',
              font: '{ "name": "Calibri", "family": 4, "size": 16, "bold": true }',
              height: 60
              },
      header: {label: ["Year", "Month", "Make", "Model", "Quantity", "Pct"] ,
               sizeCols: [10, 10, 30, 45, 10, 10] },
      dataArgs : [
            {"Fecha": "22/02/2020"},      
            {"Producto": "ROCAS"},   
            {"Proyecto": "Innovacion y Tecnologia"},   
            {"Analista": "Fidel Castro"},         
            ],
      data : [
            [2007, 1, "Volkswagen ", "Volkswagen Passat", 1267, 10],
            [2007, 1, "Toyota ", "Toyota Rav4", 819, 6.5],
            [2007, 1, "Toyota ", "Toyota Avensis", 587, 6.2],
            [2007, 1, "Volkswagen ", "Volkswagen Golf", 720, 5.7],
            [2007, 1, "Toyota ", "Toyota Corolla", 691, 5.4],
          ],
      dataJson: [
        {Year: 2007, Month: 1, Make: "KIA ", Model: "Picanto", Quantity: 1267 , Pct: 10},
        {Year: 2007, Month: 1, Make: "Mazda ", Model: "3", Quantity: 19 , Pct: 6.5},
        {Year: 2007, Month: 1, Make: "Ferrari ", Model: "Avensis", Quantity: 787 , Pct: 10},
        {Year: 2007, Month: 1, Make: "Volkswagen ", Model: "Volkswagen GOLD", Quantity: 720 , Pct: 5.7}
      ],
      validation: this.validacionCantidad
    };
    */
    const title = options.title.label;
    const subtitle = options.subtitle;
    const header = options.header.label;
    const data = options.data;
    const numCol = options.header.label.length ;
    const numRowData = options.data.length ;
    let maxLetter = String.fromCharCode(65 + numCol- 1 ) ; /// A = 65

    let fileName = options.fileName;
    let workbook = new Workbook();
    let worksheet = workbook.addWorksheet(fileName);
    let worksheetArgs = workbook.addWorksheet('Argumentos');

    // Add new row 1
    let titleRow = worksheet.addRow([title]);

    // Set font, size and style in title row.
    titleRow.font = JSON.parse(options.title.font);
    titleRow.height = options.title.height ;

    if (subtitle && options.typeFormat === 'XLSX') {
      let subtitleRow = worksheet.addRow([options.subtitle.label]);
      subtitleRow.font = JSON.parse(options.subtitle.font);
      subtitleRow.height = options.subtitle.height ;
    }

    // Blank Row 2
    let blankRow =  worksheet.addRow([]);
    blankRow.height = 2;
    blankRow.getCell(1).fill = {
      type: 'pattern',
      pattern: 'solid',
      fgColor: { argb: '808080' }
    };

    worksheet.mergeCells(`A2:${maxLetter}2`);
    // Blank Row 3
    worksheet.addRow([]);



    //Add row with current date
    // let subTitleRow = worksheet.addRow(['Date : ' + this.datePipe.transform(new Date(), 'medium')]);

    /// implementacion Imagen
    /*const logoBase64 = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAfQAAAFKCAMAAADcyF29AAA...";

    let logo = workbook.addImage({
      base64: logoBase64,
      extension: 'png',
      });
      worksheet.addImage(logo, 'E1:F2');

      worksheet.mergeCells('A1:D2');
      */

      //Add Header Row
    let headerRow = worksheet.addRow(header);

    // Cell Style : Fill and Border
    headerRow.eachCell((cell, number) => {
      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'D0D0D0' },
        bgColor: { argb: 'FF0000FF' }
      }
     cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } }
    });

    // Add Data and Conditional Formatting
    // formato de datos plano--> [ [2007, 1, "Toyota ", "Toyota Rav4", 819, 6.5],...]
    // recibe una funcion desde la invocacin y la utiliza para  colorear celdas
    data.forEach(d => {
        let row = worksheet.addRow(d);
        let qty = row.getCell(5);
        let color = 'FF99FF99';

        if (options.validation) {
        color = options.validation(qty.value);
        // if (+qty.value < 700) {
        //   color = 'FF9999'
        // }
        }
        qty.fill = {
          type: 'pattern',
          pattern: 'solid',
          fgColor: { argb: color }
        }
      }
    );

    // worksheet.addRow([]);
    options.dataJson.forEach(d => {
        const arrKeys = Object.keys(d);
        const tempRow = [];
        for(const key of arrKeys){
          let content =  d[key]  
          content =  (typeof content  === 'string' ) ?  content.replace(";", ":") : content ;
         // console.log('Tipo' + typeof content + ' ' , content )
          tempRow.push(content);
        }
        let row = worksheet.addRow(tempRow);
        //// Cutomizacion de columnas, colores, validaciones
        // let qty = row.getCell(5);
        // let color = 'FF99FF99';

        // if (options.validation) {
        // color = options.validation(qty.value);
        // // if (+qty.value < 700) {
        // //   color = 'FF9999'
        // // }
        // }

        // qty.fill = {
        //   type: 'pattern',
        //   pattern: 'solid',
        //   fgColor: { argb: color }
        // }
    }
    );

    /// construccion de argumentos / Segunda Hoja
    if (options.dataArgs) {
      options.dataArgs.forEach(d => {
        const arrKeys = Object.keys(d);
        const tempRow = [];
        let row = worksheetArgs.addRow(tempRow);
        for(const key of arrKeys){
          // tempRow.push(d[key]);
          let cell = row.getCell(1);
          cell.value = key ;
          cell.fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: 'D0D0D0' },
            bgColor: { argb: 'FF0000FF' }
          }
          cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } }

          cell = row.getCell(2);
          cell.value = d[key] ;
          cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } }

        }
      }
      );
    } else {
      let row = worksheetArgs.addRow(["No Argumentos"]);
    }
    ////

    // set size cols headers
    options.header.sizeCols.forEach((size, i) => {
      worksheet.getColumn(i + 1).width = size;
    });

    worksheet.addRow([]);

    let blankFooterRow =  worksheet.addRow([]);
    blankFooterRow.height = 2;
    blankFooterRow.getCell(1).fill = {
      type: 'pattern',
      pattern: 'solid',
      fgColor: { argb: '808080' }
    };

    worksheet.mergeCells(`A${blankFooterRow.number}:${maxLetter}${blankFooterRow.number}`);

    let footerRow = worksheet.addRow(['Fin reporte']);
    footerRow.getCell(1).font = { name: "Calibri", family: 4, size: 8, bold: true };

    // estilo line con celdas

    // //Footer Row
    // let footerRow = worksheet.addRow(['Fin reporte']);
    // footerRow.getCell(1).font = { name: "Calibri", family: 4, size: 8, bold: true };
    // footerRow.getCell(1).fill = {
    //   type: 'pattern',
    //   pattern: 'solid',
    //   fgColor: { argb: 'D0D0D0' }
    // };
    // footerRow.getCell(1).border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, 
    // right: { style: 'thin' } }
    // //Merge Cells
    // worksheet.mergeCells(`A${footerRow.number}:F${footerRow.number}`);

    if (options.typeFormat === 'XLSX'){
      workbook.xlsx.writeBuffer().then((data) => {
          let blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8' });
          FileSaver.saveAs(blob, `${fileName}.xlsx`);
        });
     } else if (options.typeFormat === 'CSV') {
      workbook.csv.writeBuffer().then((data) => {
        let blob = new Blob([data], { type: 'text/plain;charset=utf-8' });
        FileSaver.saveAs(blob, `${fileName}.csv`);
      });
     }
}

public exportToCsv(options): string {
    ///// contruccion CSV a apartir de libreria FILESAVER
    ////  ejemplo Options
   /* const options = {
      fileName : 'EstadisticoVentas',
      header: {label: ["Year", "Month", "Make", "Model", "Quantity", "Pct"]},
      dataJson: [
        {Year: 2007, Month: 1, Make: "KIA ", Model: "Picanto", Quantity: 1267 , Pct: 10},
        {Year: 2007, Month: 1, Make: "Mazda ", Model: "3", Quantity: 19 , Pct: 6.5},
        {Year: 2007, Month: 1, Make: "Ferrari ", Model: "Avensis", Quantity: 787 , Pct: 10},
        {Year: 2007, Month: 1, Make: "Volkswagen ", Model: "Volkswagen, GOLD", Quantity: 720 , Pct: 5.7}
      ]
    };
    */

    const rows: object[] = options.dataJson;
    const fileName: string = options.fileName;
    const columns: string[] = options.header.label;

    if (!rows || !rows.length) {
      return;
    }
    const separator = ',';
    const keys = Object.keys(rows[0]).filter(k => {
      if (columns.length) {
        return columns.includes(k);
      } else {
        return true;
      }
    });
    const csvContent =
      keys.join(separator) +
      '\n' +
      rows.map(row => {
        return keys.map(k => {
          let cell = row[k] === null || row[k] === undefined ? '' : row[k];
          cell = cell instanceof Date
            ? cell.toLocaleString()
            : cell.toString().replace(/"/g, '""');
          if (cell.search(/("|,|\n)/g) >= 0) {
            cell = `"${cell}"`;
          }
          return cell;
        }).join(separator);
      }).join('\n');

    const data: Blob = new Blob([csvContent], { type: CSV_TYPE });
    FileSaver.saveAs(data,  `${fileName}${CSV_EXTENSION}`);

  }

  //Servicio para exportar reportes jasper para PDF y EXCEL
  executeReport(report, format, title) {
    return new Promise(resolve => {
      let file;
      let fileURL;
      if(format === 'pdf'){
        file = new Blob ([report as BlobPart], {type: 'application/pdf'});
        FileSaver.saveAs(file, `${title.replace(' ', '_')}_${new Date().toLocaleDateString()}_${new Date().toLocaleTimeString()}.pdf`); // this is FileSaver.js function (npm Install file-saver --save)
      }if(format === 'pdfHist'){
        file = new Blob ([report as BlobPart], {type: 'application/pdf'});
        FileSaver.saveAs(file, `${title.replace(' ', '_')}.pdf`); // this is FileSaver.js function (npm Install file-saver --save)
      }else if(format ==='xls'){
        file = new Blob ([report as BlobPart], {type: 'application/xls'});
        FileSaver.saveAs(file, `${title.replace(' ', '_')}_${new Date().toLocaleDateString()}_${new Date().toLocaleTimeString()}.xls`); // this is FileSaver.js function (npm Install file-saver --save)
      }else if(format ==='xlsm'){
        file = new Blob ([report as BlobPart], {type: 'application/xlsm'});
        FileSaver.saveAs(file, `${title.replace(' ', '_')}_${new Date().toLocaleDateString()}_${new Date().toLocaleTimeString()}.xlsm`); // this is FileSaver.js function (npm Install file-saver --save)
      }else if(format ==='xlsx'){
        let file = new Blob([report], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' 
      });
        FileSaver.saveAs(file, `${title.replace(' ', '_')}_${new Date().toLocaleDateString()}_${new Date().toLocaleTimeString()}.xlsx`); // this is FileSaver.js function (npm Install file-saver --save)
      }
      return resolve(true);
    });
  }

}
